import { useEffect } from 'react'
import { Outlet, createRootRoute, useRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'

import { AuthContext, useAuthProvider } from '@/hooks/use-auth'
import { ErrorBoundary } from '@/components/error-boundary'
import { applyUpdateOnNavigation, registerPwaUpdater } from '@/lib/pwa-updater'
import { queryClient } from '@/router'

export const Route = createRootRoute({
    component: RootComponent,
})

function RootComponent() {
    const router = useRouter()
    useEffect(() => {
        registerPwaUpdater()
    }, [])
    useEffect(() => applyUpdateOnNavigation(router), [router])

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <AuthProvider />
                <Toaster position="top-center" richColors />
            </QueryClientProvider>
        </ErrorBoundary>
    )
}

function AuthProvider() {
    const auth = useAuthProvider()
    return (
        <AuthContext.Provider value={auth}>
            <Outlet />
        </AuthContext.Provider>
    )
}
